import React from 'react';
import Modal from '../Modal';
import styles from './CustomThumbnailModal.module.scss';

function CustomThumbnailModal({ open, onClose, children, ...rest }) {
  return (
    <Modal className={styles.customThumbnailModal} open={open} onClose={onClose} {...rest}>
      {children}
    </Modal>
  );
}

export default CustomThumbnailModal;
